import { jsx as _jsx } from "react/jsx-runtime";
import * as Icons from '@ant-design/icons';
import UIButton from './uiButton';
import UIField from './uiField';
import UIDate from './uiDate';
import UIRange from './uiRange';
import UIRadio from './uiRadio';
import UISelect from './uiSelect';
import UIDivider from './uiDivider';
import UIText from './uiText';
import UICheckbox from './uiCheckbox';
import UITable from './uiTable';
import UIAligner from './uiAligner';
import UIImageButton from './uiImageButton';
import UIGrid from './uiGrid';
import UIPlaceholder from './uiPlaceholder';
import UIUploader from './uiUploader';
import UIAnchor from './uiAnchor';
import UIIconButton from './uiIconButton';
import UiInlineGrid from './uiInlineGrid';
import UIBlock from './uiBlock';
import UIImageHeader from './uiImageHeader';
import UILabel from './uiLabel';
import UISlot from './uiSlot';
import { UICheckboxField, UIFormatTemplateSelection, UINotesSourceHeader, UIBinaryRadio } from './index';
export function isEmpty(v) {
    if (v === undefined) {
        return true;
    }
    if (v === null) {
        return true;
    }
    if (v === '') {
        return true;
    }
    return false;
}
export const DynamicIcon = ({ iconName, style }) => {
    const IconComponent = Icons[iconName]; // Type assertion for dynamic access
    if (!IconComponent) {
        return _jsx("span", { style: { color: 'red' }, children: "Icon not found" });
    }
    return _jsx(IconComponent, { style: style });
};
export function resovleContent(component, s) {
    if ('content' in s) {
        for (const c of s.content) {
            if ('button' in c) {
                component.children.push(new UIButton(c.button));
            }
            else if ('field' in c) {
                component.children.push(new UIField(c.field));
            }
            else if ('date' in c) {
                component.children.push(new UIDate(c.date));
            }
            else if ('range' in c) {
                component.children.push(new UIRange(c.range));
            }
            else if ('radio' in c) {
                component.children.push(new UIRadio(c.radio));
            }
            else if ('select' in c) {
                component.children.push(new UISelect(c.select));
            }
            else if ('divider' in c) {
                component.children.push(new UIDivider(c.divider));
            }
            else if ('text' in c) {
                component.children.push(new UIText(c.text));
            }
            else if ('checkbox' in c) {
                component.children.push(new UICheckbox(c.checkbox));
            }
            else if ('table' in c) {
                component.children.push(new UITable(c.table));
            }
            else if ('aligner' in c) {
                component.children.push(new UIAligner(c.aligner));
            }
            else if ('imageButton' in c) {
                component.children.push(new UIImageButton(c.imageButton));
            }
            else if ('grid' in c) {
                component.children.push(new UIGrid(c.grid));
            }
            else if ('placeholder' in c) {
                component.children.push(new UIPlaceholder(c.placeholder));
            }
            else if ('uploader' in c) {
                component.children.push(new UIUploader(c.uploader));
            }
            else if ('anchor' in c) {
                component.children.push(new UIAnchor(c.anchor));
            }
            else if ('iconButton' in c) {
                component.children.push(new UIIconButton(c.iconButton));
            }
            else if ('inlineGrid' in c) {
                component.children.push(new UiInlineGrid(c.inlineGrid));
            }
            else if ('block' in c) {
                component.children.push(new UIBlock(c.block));
            }
            else if ('imageHeader' in c) {
                component.children.push(new UIImageHeader(c.imageHeader));
            }
            else if ('label' in c) {
                component.children.push(new UILabel(c.label));
            }
            else if ('slot' in c) {
                component.children.push(new UISlot(c.slot));
            }
            else if ('formatTemplateSelection' in c) {
                component.children.push(new UIFormatTemplateSelection(c.formatTemplateSelection));
            }
            else if ('checkboxField' in c) {
                component.children.push(new UICheckboxField(c.checkboxField));
            }
            else if ('uiNotesSourceHeader' in c) {
                component.children.push(new UINotesSourceHeader(c.uiNotesSourceHeader));
            }
            else if ('binaryRadio' in c) {
                component.children.push(new UIBinaryRadio(c.binaryRadio));
            }
        }
    }
}
//# sourceMappingURL=utils.js.map